export default class NewsFilters {

    constructor($filters, $articlesContainer, $articlesSection) {

        this.$filters = $filters;
        this.$articlesContainer = $articlesContainer;
        this.$articlesSection = $articlesSection;

        this.$articlesHolder = $articlesContainer.find('.js-articles');

        this.request = null;

        this.filters = {types: ['news', 'events']};

        this.bindEvents();
    }

    bindEvents() {
        let me = this;

        this.filters = this.$filters.serializeJSON();

        this.$filters.on('change', '.js-filter-checkbox', () => {
            this.updateFilters();
        });

        window.onpopstate = function (event) {

            let types = ['news', 'events'];

            let regexp = new RegExp('^/news-and-events/(?:type/([^/]+)/)?(?:page/([0-9]+)/)?');

            let pattern = regexp.exec(window.location.pathname);

            let filters = {
                types: (typeof pattern[1]) !== 'undefined' ? [pattern[1]] : types,
                page: (typeof pattern[2]) !== 'undefined' ? parseInt(pattern[2]) : 1,
            };

            me.$filters.find('input[type="checkbox"]').prop('checked', false);

            filters.types.forEach((value) => {
                me.$filters.find('input[type="checkbox"][value="' + value + '"]').prop('checked', true);
            });

            me.updatePosts(filters, false);
        };
    }

    updateFilters() {
        if (this.request !== null) {
            this.request.abort();
        }

        this.filters = this.$filters.serializeJSON();

        this.filters.page = 1;

        if ('undefined' === typeof this.filters.types) {
            this.filters.types = ['news', 'events'];
        }

        this.updatePosts(this.filters, true);
    }

    updatePosts(filters, pushState) {
        this.$articlesSection.addClass('section--loading').removeClass('section--no-articles');

        this.request = Ajax.get('mgts/v1', 'posts/', {
            types: filters.types,
            page: filters.page,
        }, Ajax.WEBSITE);

        this.request.then((data) => {
            this.request = null;
            this.buildPosts(data);
            this.buildPagination(data);
        }).catch((e) => {
            this.request = null;
            console.error(e);
        });

        if (pushState) {
            history.pushState({}, '', this.pageUrl());
        }
    }

    buildPosts(data) {
        this.$articlesHolder.html('');

        if (data.posts.length <= 0) {
            this.showNoArticlesMessage();
        } else {
            data.posts.forEach((post) => {
                this.$articlesHolder.append(this.buildPost(post));
            });
        }

        this.$articlesSection.removeClass('section--loading');
    }

    buildPost(post) {
        let event_date = post.event_date;

        if (post.event_time !== null) {
            event_date += ', ' + post.event_time;
        }

        let additionalPostCategory = post.colour !== 'default' ? 'post-category--' + post.colour : '';
        let additionalReadMore = post.colour !== 'default' ? 'read-more--' + post.colour : '';

        return (
            eotwJSXFactory('div', {className: "columns__column"}, [
                eotwJSXFactory('article', {className: "card card--news card--news-page"}, [
                    eotwJSXFactory('aside', {className: "card__aside"}, [
                        eotwJSXFactory('div', {className: "card__image", unsafeHtml: post.image}),
                        eotwJSXFactory('div', {className: "post-category post-category--card post-category--small " + additionalPostCategory}, [post.category]),
                        eotwJSXFactory('div', {className: "card__meta"}, [
                            eotwJSXFactory('div', {className: "post-type post-type--card"}, [eotwJSXFactory('span', {className: "post-type__icon", unsafeHtml: '<svg><use xlink:href="/wp-content/themes/mgts/includes/svg-icons.svg?#' + post.type + '-icon"></use></svg>'}),post.type]),
                            eotwJSXFactory('div', {className: "post-date post-date--card"}, [post.type === 'news' ? post.date : event_date])
                        ])
                    ]),
                    eotwJSXFactory('div', {className: "card__content"}, [
                        eotwJSXFactory('h2', {className: "heading heading--4"}, [eotwJSXFactory('a', {className: "psuedo-link", href: post.link}, [post.title])]),
                        eotwJSXFactory('p', null, [post.excerpt]),
                        eotwJSXFactory('div', {className: "card__button read-more " + additionalReadMore}, ["Read More"])
                    ])
                ])
            ])
        );
    }

    showNoArticlesMessage() {
        this.$articlesSection.addClass('section--no-articles');

        this.$articlesHolder.append(
            eotwJSXFactory('div', {className: "no-articles"}, [
                eotwJSXFactory('div', {className: "no-articles__content"}, [
                    eotwJSXFactory('div', {className: "no-articles__icon", unsafeHtml: '<svg><use xlink:href="/wp-content/themes/mgts/includes/svg-icons.svg?#no-news-icon"></use></svg>'}),
                    eotwJSXFactory('h2', {className: "no-articles__label"}, ["Sorry, there's no articles to show"])
                ])
            ]),
        );
    }

    getPageLink(base, i) {
        let link = base;

        if (i !== 1) {
            link += 'page/' + i + '/';
        }

        return link;
    }

    pageUrl() {
        let base = '/news-and-events/';

        if ((typeof this.filters.types) !== 'undefined' && this.filters.types.length === 1) {
            base += 'type/' + this.filters.types[0] + '/';
        }

        return base;
    }

    buildPagination(data) {
        let $paginationHolder = this.$articlesSection.find('.js-pagination-holder');
        $paginationHolder.html('');

        let $pagination = (eotwJSXFactory('div', {className: "pagination__wrap js-pagination"}));

        let paged = data.paged;
        let pages = data.max_num_pages;
        let range = 2;
        let showItems = (range * 2) + 1;

        let base = this.pageUrl();

        if (pages <= 1) return;

        if (paged > 1) {
            $pagination.append(
                eotwJSXFactory('a', {href: this.getPageLink(base, paged - 1), className: "pagination__link pagination__link--direction"}, ["Previous"]),
            );
        }

        let $list = (eotwJSXFactory('ol', {className: "pagination__list"}));

        for (let i = 1; i <= pages; i++) {
            if (1 !== pages && (!(i >= paged + range + 1 || i <= paged - range - 1) || pages <= showItems)) {
                $list.append(
                    eotwJSXFactory('li', {className: "pagination__item"}, [
                        paged === i ? (
                            eotwJSXFactory('span', {className: "pagination__link pagination__link--active"}, [i])
                        ) : (
                            eotwJSXFactory('a', {href: this.getPageLink(base, i), className: "pagination__link"}, [i])
                        )
                    ]),
                );
            }
        }

        $pagination.append($list);


        if (paged < pages) {
            $pagination.append(
                eotwJSXFactory('a', {href: this.getPageLink(base, paged + 1), className: "pagination__link pagination__link--direction pagination__link--direction-next"}, ["Next"]),
            );
        }

        $paginationHolder.html(
            eotwJSXFactory('nav', {className: "pagination"}, [
                $pagination
            ]),
        );
    }
}
